import axios from "axios";
import { def } from "../../config";

/**
 * Dedicated client for the internal issue logger API.
 * Uses a separate base URL and never touches the main auth session.
 */
export default async function fetchLogger({
  method = "GET",
  url,
  data,
  params,
  headers = {},
}) {
  try {
    const res = await axios({
      method,
      url: `${def.loggerApi}${url}`,
      data,
      params,
      headers: {
        ...headers,
        ...(def.loggerApiKey ? { "x-api-key": def.loggerApiKey } : {}),
      },
    });
    return { ok: true, status: res.status, data: res.data };
  } catch (err) {
    if (!err?.response) {
      return {
        ok: false,
        status: 0,
        data: {
          message: "Network Error! Unable to reach the logger service.",
          error: "Network Error",
          statusCode: 0,
        },
      };
    }
    return {
      ok: false,
      status: err.response.status,
      data: err.response.data,
    };
  }
}
